"use client"
 
import { useEffect } from "react"
import './Leadership2.css'
 
export default function ProfileModal({ member, onClose }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose()
      }
    }
 
    document.addEventListener("keydown", handleEscape)
    document.body.style.overflow = "hidden"
 
    return () => {
      document.removeEventListener("keydown", handleEscape)
      document.body.style.overflow = "unset"
    }
  }, [onClose])
 
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }
 
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center p-4"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.7)", zIndex: 1050 }}
      onClick={handleBackdropClick}
    >
      <div
        className="container position-relative bg-light rounded-4 shadow-lg overflow-hidden"
        style={{ maxWidth: "960px", maxHeight: "90vh" }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="btn btn-sm btn-close position-absolute top-0 end-0 m-3"
          aria-label="Close"
        ></button>
 
        <div className="row g-0">
          {/* Left Side - Image */}
          <div className="col-md-6">
            <img
              src={member.image || "/placeholder.svg"}
              alt={member.name}
              className="img-fluid h-100 object-fit-cover"
              style={{ minHeight: "400px", objectFit: "cover" }}
            />
          </div>
 
          {/* Right Side - Content */}
          <div className="col-md-6 p-4 d-flex flex-column justify-content-start">
            <div className="mb-4">
              <h2 className="h3 fw-bold text-dark">{member.name}</h2>
              <p className="text-muted fs-5">{member.role}</p>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block mb-3"
              >
                <svg width="32" height="32" viewBox="0 0 24 24" fill="#0077b5">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
 
            {/* Description */}
            <div style={{ maxHeight: "200px" }}>
              <p className="text-secondary lh-base">{member.desc}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}